<div class="row action-toolbar" style="margin-top: 20px">
    <div class="col-12">
        <form class="form-inline">
            <div class="input-header-group">
                <span class="input-header">Bid Date Start</span>
                <wj-input-date
                    [(ngModel)]="startDate"
                    class="header-input"
                    name="startDate"
                    (ngModelChange)="refresh()"
                    [selectionMode]="'Month'"
                    [format]="'MMM yyyy'"
                    [min]="minDate"
                    [max]="maxDate"
                ></wj-input-date>
            </div>

            <div class="input-header-group">
                <span class="input-header">Bid Date End</span>
                <wj-input-date
                    [(ngModel)]="endDate"
                    class="header-input"
                    name="endDate"
                    (ngModelChange)="refresh()"
                    [selectionMode]="'Month'"
                    [format]="'MMM yyyy'"
                    [min]="minDate"
                    [max]="maxDate"
                ></wj-input-date>
            </div>

            <div class="input-header-group">
                <span class="input-header">Time Unit</span>
                <wj-combo-box
                    [(ngModel)]="selectedTimeUnit"
                    name="selectedTimeUnit"
                    (ngModelChange)="refresh()"
                    [itemsSource]="timeUnits"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>

            <div class="input-header-group">
                <span class="input-header">Job Type</span>
                <wj-combo-box
                    [(ngModel)]="selectedJobType"
                    name="selectedJobType"
                    (ngModelChange)="refresh()"
                    [itemsSource]="jobTypesList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12" *ngIf="chartData">
        <wj-flex-chart
            appAutoSize
            [itemsSource]="chartData.points"
            [bindingX]="'label'"
            [chartType]="chartData.chartType"
            [header]="chartData.title"
            [legendToggle]="true"
        >
            <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
            <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Revenue'" [format]="chartData.yAxisFormat" [min]="0"></wj-flex-chart-axis>
            <wj-flex-chart-series *ngFor="let serie of chartData.series" [binding]="serie.binding" [name]="serie.name">
            </wj-flex-chart-series>
        </wj-flex-chart>
    </div>
</div>
